// src/lib/opportunity/oppTodoTemplateClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OppTodoTemplateScope, OppTodoTemplateStep } from "./oppTodoTemplateTypes.js";

export function listOppTodoTemplateSteps(params: {
  scope?: OppTodoTemplateScope;
  product_type?: string;
}) {
  const q = new URLSearchParams();
  if (params.scope) q.set("scope", params.scope);
  if (params.product_type) q.set("product_type", params.product_type);
  const suffix = q.toString() ? `?${q.toString()}` : "";
  return opportunityFetch<{ ok: true; steps: OppTodoTemplateStep[] }>(
    `/api/opportunity/todo-template-list${suffix}`,
    { method: "GET" },
  );
}

export type UpsertOppTodoTemplateStepPayload = {
  id?: string;
  scope?: OppTodoTemplateScope;
  product_type?: string | null;
  label: string;
  sort_order?: number;
  default_due_offset_days?: number | null;
  is_active?: boolean;
};

export function upsertOppTodoTemplateStep(payload: UpsertOppTodoTemplateStepPayload) {
  return opportunityFetch<{ ok: true; step: OppTodoTemplateStep }>(
    "/api/opportunity/todo-template-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteOppTodoTemplateStep(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/todo-template-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderOppTodoTemplateSteps(payload: {
  scope: OppTodoTemplateScope;
  product_type?: string | null;
  ordered_ids: string[];
}) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/todo-template-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
